"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M-564-232h2000V968H-564z"
  }), __jsx("g", {
    transform: "translate(-20 -14)"
  }, __jsx("rect", {
    stroke: "#E6E9EB",
    strokeWidth: 1.5,
    x: 0.75,
    y: 0.75,
    width: 302.5,
    height: 46.5,
    rx: 23.25
  }), __jsx("g", {
    strokeWidth: 1.5,
    transform: "translate(20.833 14.833)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, __jsx("path", {
    d: "M.05 1.3v5.214a2.5 2.5 0 00.732 1.768l9.635 9.635a1.25 1.25 0 001.767 0l5.733-5.734a1.25 1.25 0 000-1.767L8.282.782A2.5 2.5 0 006.516.05H1.301C.61.05.05.61.05 1.3z"
  }), __jsx("circle", {
    cx: 4.426,
    cy: 4.425,
    r: 1.25
  })))));
}
var _default = exports.default = SvgComponent;